import { FetchError, ResponseError } from '../../gen/openapi';

export const TIMEOUT_ERROR_MESSAGE =
  'Guardian took too long to respond. Please try again — if it keeps happening, try a more specific question.';
export const NETWORK_ERROR_MESSAGE = 'Unable to reach Guardian. Check your network connection and try again.';
export const GENERIC_ERROR_MESSAGE = "Guardian couldn't process your request. Please try again.";

/**
 * Maps a chat mutation failure to user-facing copy. The generated client throws
 * ResponseError (HTTP error status, body unread) or FetchError (network drop);
 * anything else gets the generic copy.
 */
export const getChatErrorMessage = async (error: Error): Promise<string> => {
  if (error instanceof ResponseError) {
    if (error.response.status === 504) return TIMEOUT_ERROR_MESSAGE;
    const detail = await error.response
      .json()
      .then((data) => data?.detail)
      .catch(() => undefined);
    // FastAPI 422 validation errors carry an array `detail` — only surface plain strings.
    return typeof detail === 'string' ? detail : GENERIC_ERROR_MESSAGE;
  }
  if (error instanceof FetchError) return NETWORK_ERROR_MESSAGE;
  return GENERIC_ERROR_MESSAGE;
};
